import './App.scss';
import {Header} from './components/layout/Header/Header';
import {Route, Routes} from 'react-router-dom';
import {About} from './components/pages/About';
import {Home} from './components/pages/Home';
import {Contact} from './components/pages/Contact';
import {NotFound} from './components/pages/NotFound';
import {ProjectsOverviewPage} from './components/pages/ProjectsOverviewPage/ProjectsOverviewPage';
import {ProjectDetailPage} from './components/pages/ProjectDetailPage/ProjectDetailPage';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Header />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="projects" element={<ProjectsOverviewPage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="projects/:projectPath" element={<ProjectDetailPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
